// extracted by mini-css-extract-plugin
module.exports = {"root":"Option_root__2OeMq","row":"Option_row__JMhor"};